import type { LiderAsignacionHoy } from 'schemas';

/**
 * Programación con la que el L2 captura una línea. Un líder puede tener la
 * misma línea en varios turnos del día (p. ej. el tenant de demostración la
 * programa en T1, T2 y T3): se prefiere la del turno en curso y, si ninguna lo
 * es, la primera, como antes.
 */
export function programacionDeLinea(
  programaciones: LiderAsignacionHoy[],
  lineaId: string | undefined,
  turnoActualId: string | null,
): LiderAsignacionHoy | undefined {
  const deLinea = programaciones.filter((p) => p.linea.id === lineaId);
  return deLinea.find((p) => p.turno.id === turnoActualId) ?? deLinea[0];
}
